import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveHtmlDocumentTemplates,
  submitUpdateHtmlDocumentTemplate,
  submitUpdateHtmlDocumentTemplatesVisibility
} from '~/api/data/html-templates/mutations';
import {
  loadHtmlDocumentTemplate,
  loadHtmlDocumentTemplates
} from '~/api/data/html-templates/queries';
import { LibraryTemplatesPage, TemplateEditPage } from '~/pages/library/templates';

// Templates have no manual /new route — new templates are authored via the
// Cara workspace flow (CreateTemplateWorkspaceDialog) and saved back to the
// library from inside the workspace via the GraphQL mutation directly.
const templatesLibraryChildren = [
  {
    path: 'archive',
    action: byMethod({
      POST: submitArchiveHtmlDocumentTemplates
    })
  },
  {
    path: 'visibility',
    action: byMethod({
      POST: submitUpdateHtmlDocumentTemplatesVisibility
    })
  },
  {
    path: ':id',
    loader: merge({
      htmlDocumentTemplate: loadHtmlDocumentTemplate,
      htmlDocumentTemplates: loadHtmlDocumentTemplates
    }),
    action: byMethod({
      PUT: submitUpdateHtmlDocumentTemplate
    }),
    element: <TemplateEditPage />
  }
];

export const templatesRoute: RouteObject = {
  path: 'templates',
  loader: merge({
    htmlDocumentTemplates: loadHtmlDocumentTemplates
  }),
  element: <LibraryTemplatesPage />,
  children: templatesLibraryChildren
};
